import PropTypes from 'prop-types';
import {CreateUpdateEntityDialog} from '@ozgene/gp5.components.create-update-entity-dialog';
import TagEditor from 'Sbs/components/TagEditor';

export default function CreateTagDialog(props) {
  const {onClose, onSave, defaultText, initialData} = props;
  const handleSave = (entity) => onSave(entity);

  return (
    <CreateUpdateEntityDialog
      entityType="Tag"
      EditorComponent={TagEditor}
      defaultText={defaultText}
      initialData={initialData}
      onSave={handleSave}
      onClose={onClose}
    />
  );
}

CreateTagDialog.propTypes = {
  defaultText: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  initialData: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

CreateTagDialog.defaultProps = {
  entity: null,
  initialData: null,
  defaultText: '',
};
